import apiClient from "../helpers/apiClient";
import { handleApiError, parseApiErrors } from "../utils/handleApiError";
import { showErrorAlert } from "../helpers/alert";
import { offset } from "@popperjs/core";

const Logout = () => {
    window.location.href = '/';
}

export async function getCategories() {
    try {
        // PR-I-76: catalogo user-facing. Solo activas y ordenadas por `order`
        // (definido en el admin de categorias). `ordering=order` es explicito
        // para blindar el default del backend por si cambia.
        const response = await apiClient.get(`/experiences/categories/`, {params:{search: '', limit:1000, offset:0, isActive: true, ordering: 'order'}});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getAudiences() {
    try {
        const response = await apiClient.get(`/experiences/audiences/`, {});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getDurations() {
    try {
        const response = await apiClient.get(`/experiences/duration-types/`, {});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getConfidentialityLevels() {
    try {
        const response = await apiClient.get(`/experiences/confidentiality-levels/`, {});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getBeneficiaries() {
    try {
        const response = await apiClient.get(`/experiences/beneficiaries/`, {});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getMyTeamMembers(search: string, limit?: number, offset?: number) {
    try {
        const params: any = { key: search };
        if (limit !== undefined) params.limit = limit;
        if (offset !== undefined) params.offset = offset;
        const response = await apiClient.get(`/my-team/search/`, { params });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getUsersSubscribed(search: string) {
    try {
        const response = await apiClient.get(`/users/search/subscribed/`, { params: { key: search } });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getHost(params: any={}) {
    try {
        const response = await apiClient.get(`/hosts/`, { params: params });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

/* experiencias */

export async function createExperience(data: any) {
    try {
        const response = await apiClient.post(`/experiences/`, data,{ 
            headers: { 
                Accept: 'application/json',
                "Content-Type": "application/json",
            } 
        });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function addImagesToExperience(id: number, formData: FormData) {
    try {
        const response = await apiClient.patch(`/experiences/${id}/`, formData, { 
            headers: { 
                Accept: 'application/json',
                "Content-Type": "multipart/form-data",
            } 
        });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function updateExperience(id:number,data: any) {
    try {
        const response = await apiClient.put(`/experiences/${id}/`,data,{ 
            headers: { 
                Accept: 'application/json',
                "Content-Type": "application/json",
            } 
        });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getDetailExperience(id:number) {
    try {
        const response = await apiClient.get(`/experiences/${id}/`, {});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getExperiences(params:any={}) {
    try {
        const response = await apiClient.get(`/experiences/`, { params: params });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function deleteExperience(id:number) {
    try {
        const response = await apiClient.delete(`/experiences/${id}/`, {});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getRequestedExperiences(params:any={}) {
    try {
        const response = await apiClient.get(`/experiences/admin/pending/`, { params: params });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function approveExperience(id:number) {
    try {
        const response = await apiClient.post(`/experiences/admin/experiences/${id}/approve/`, {});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function rejectExperience(id:number) {
    try {
        const response = await apiClient.put(`/experiences/admin/experiences/${id}/reject/`, {rejectionReasonId:1, rejectionNote:'test'});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getActiveExperiences(params:any={}) {
    try {
        const response = await apiClient.get(`/experiences/management/list/`, { params: params });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getPastExperiences(params:any={}) {
    try {
        const response = await apiClient.get(`/experiences/my-history/`, { params: params });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getExperienceCandidates(id:number,params:any) {
    try {
        const response = await apiClient.get(`/experiences/${id}/candidates/`, { params:params});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getExperienceGuests(id:number) {
    try {
        const response = await apiClient.get(`/experiences/${id}/guests/`, { params:{limit:1000}});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function sendExperienceInvite(id:number, inviteeIds:[]) {
    try {
        const response = await apiClient.post(`/experiences/${id}/invite/`, { user_ids: inviteeIds });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getGuestsExperiences(id:number) {
    try {
        const response = await apiClient.get(`/experiences/${id}/guests/`, { });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getRequestExperiences(params:any={}) {
    try {
        const response = await apiClient.get(`/experiences/bookings/requests/`, { params: params });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function acceptExperienceInvitation(id:number) {
    try {
        const response = await apiClient.post(`/experiences/bookings/${id}/accept/`, {});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function rejectExperienceInvitation(id:number) {
    try {
        const response = await apiClient.post(`/experiences/bookings/${id}/reject/`, {});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function deleteExperienceImage(experienceId: number, imageId: number) {
    try {
        const response = await apiClient.post(`/experiences/${experienceId}/delete-image/`, { image_id: imageId });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}